import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetEditUserInfo = () => {
  const [loading, setLoading] = useState(false);
  const [editUserInfo, setEditUserInfo] = useState(null);

  const { enqueueSnackbar } = useSnackbar();

  const getEditUserInfo = guid => {
    setLoading(true);
    setEditUserInfo(null);

    axiosClient
      .get(`SettingAccount/User/Update?GUID=${guid}`)
      .then(res => {
        if (res.status === 200) {
          setEditUserInfo(res.data.value);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [getEditUserInfo, loading, editUserInfo];
};

export default useGetEditUserInfo;
